
function formatMoney(cents) {
  var value = Math.round(cents);
  var euros = Math.floor(value / 100);
  var centsPart = value % 100;
  return '€' + euros + ',' + (centsPart < 10 ? '0' : '') + centsPart;
}

var wishlistKey = 'es-wishlist';
function getWishlist() {
  try { return JSON.parse(localStorage.getItem(wishlistKey)) || []; } catch(e) { return []; }
}
function toggleWishlist(btn, handle) {
  var list = getWishlist();
  var idx = list.indexOf(handle);
  if (idx > -1) { list.splice(idx, 1); btn.classList.remove('active'); }
  else { list.push(handle); btn.classList.add('active'); }
  localStorage.setItem(wishlistKey, JSON.stringify(list));
}
function toggleWishlistRow(handle) {
  var btn = document.getElementById('wishlistRowBtn');
  var text = document.getElementById('wishlistRowText');
  var list = getWishlist();
  var idx = list.indexOf(handle);
  if (idx > -1) {
    list.splice(idx, 1);
    btn.classList.remove('active');
    text.textContent = 'Save to wishlist';
  } else {
    list.push(handle);
    btn.classList.add('active');
    text.textContent = 'Saved to wishlist';
  }
  localStorage.setItem(wishlistKey, JSON.stringify(list));
}
document.addEventListener('DOMContentLoaded', function() {
  var list = getWishlist();
  document.querySelectorAll('.wishlist-btn').forEach(function(btn) {
    var card = btn.closest('[data-product-handle]');
    if (card && list.indexOf(card.getAttribute('data-product-handle')) > -1) btn.classList.add('active');
  });
  var rowBtn = document.getElementById('wishlistRowBtn');
  var rowText = document.getElementById('wishlistRowText');
  if (rowBtn && rowBtn.dataset.handle && list.indexOf(rowBtn.dataset.handle) > -1) {
    rowBtn.classList.add('active');
    rowText.textContent = 'Saved to wishlist';
  }
});

function setAnnouncementOffset() {
  var bar = document.querySelector('.announcement-bar');
  var h = bar ? bar.offsetHeight : 0;
  document.documentElement.style.setProperty('--announcement-height', h + 'px');
}
setAnnouncementOffset();
window.addEventListener('resize', setAnnouncementOffset);

var scrollLogoGhost = document.getElementById('scrollLogoGhost');
var heroEl = document.querySelector('.hero');
var quoteEl = document.querySelector('.quote-section');
if (scrollLogoGhost && heroEl) {
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    var heroBottom = heroEl.offsetHeight;
    var quoteBottom = quoteEl ? (quoteEl.offsetTop + quoteEl.offsetHeight) : (heroBottom + 400);

    if (y < heroBottom) {
      scrollLogoGhost.classList.remove('header-phase', 'faded-out');
      scrollLogoGhost.style.opacity = y > 20 ? 1 : 0;
    } else if (y < quoteBottom) {
      scrollLogoGhost.classList.add('header-phase');
      scrollLogoGhost.classList.remove('faded-out');
      scrollLogoGhost.style.opacity = '';
    } else {
      scrollLogoGhost.classList.add('header-phase', 'faded-out');
    }
  }, { passive: true });
}

var nav = document.getElementById('nav');
if (nav && nav.classList.contains('transparent')) {
  window.addEventListener('scroll', function () {
    var scrolledPast = window.scrollY > 20;
    nav.classList.toggle('scrolled', scrolledPast);
    nav.classList.toggle('transparent', !scrolledPast);
  });
}

function openDrawer() {
  document.getElementById('drawer').classList.add('open');
  document.getElementById('overlay').classList.add('active');
  document.body.style.overflow = 'hidden';
}
function closeDrawer() {
  document.getElementById('drawer').classList.remove('open');
  document.getElementById('overlay').classList.remove('active');
  document.body.style.overflow = '';
}
function openSearch() {
  document.getElementById('searchOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(function () { document.getElementById('searchInput').focus(); }, 100);
}
function closeSearch() {
  document.getElementById('searchOverlay').classList.remove('open');
  document.body.style.overflow = '';
  document.getElementById('searchInput').value = '';
  handleSearch('');
}
function setSearch(val) {
  document.getElementById('searchInput').value = val;
  handleSearch(val);
}
function handleSearch(query) {
  var suggestions = document.getElementById('searchSuggestions');
  var results = document.getElementById('searchResults');
  var noResults = document.getElementById('searchNoResults');
  var grid = document.getElementById('searchResultsGrid');
  var label = document.getElementById('searchResultsLabel');
  var noResultsText = document.getElementById('searchNoResultsText');
  if (!suggestions) return;
  if (!query.trim()) {
    suggestions.style.display = 'block';
    results && results.classList.remove('show');
    noResults && noResults.classList.remove('show');
    return;
  }
  suggestions.style.display = 'none';
  fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = data.resources.results.products || [];
      if (products.length > 0) {
        results.classList.add('show');
        noResults.classList.remove('show');
        label.textContent = products.length + ' result' + (products.length > 1 ? 's' : '') + ' for "' + query + '"';
        grid.innerHTML = products.map(function (p) {
          var img = p.featured_image ? p.featured_image.url : '';
          var price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
          return '<a class="search-result-card" href="' + p.url + '">' +
            (img ? '<img class="search-result-img" src="' + img + '" alt="' + p.title + '" loading="lazy">' : '<div class="search-result-img"></div>') +
            '<div class="search-result-name">' + p.title + '</div>' +
            '<div class="search-result-price">' + price + '</div>' +
            '</a>';
        }).join('');
      } else {
        results.classList.remove('show');
        noResults.classList.add('show');
        noResultsText.innerHTML = 'No results for <strong style="color:var(--charcoal);">"' + query + '"</strong>.<br>Try jacket, shirt, trousers or shorts.';
      }
    })
    .catch(function () {
      noResults.classList.add('show');
      noResultsText.textContent = 'Search unavailable. Try browsing the collection.';
    });
}
function closeModal() {
  var overlay = document.getElementById('modalOverlay');
  var sheet = document.getElementById('modalSheet');
  if (overlay) overlay.classList.remove('show');
  if (sheet) sheet.classList.remove('show');
  document.body.style.overflow = '';
}
function showModal(name, variantTitle, price, image) {
  var modalName = document.getElementById('modalName');
  var modalMeta = document.getElementById('modalMeta');
  var modalPrice = document.getElementById('modalPrice');
  var modalImg = document.getElementById('modalImg');
  if (modalName) modalName.textContent = name;
  if (modalMeta) modalMeta.textContent = variantTitle || '';
  if (modalPrice) modalPrice.textContent = price || '';
  if (modalImg && image) { modalImg.src = image; modalImg.style.display = 'block'; }
  var overlay = document.getElementById('modalOverlay');
  var sheet = document.getElementById('modalSheet');
  if (overlay) overlay.classList.add('show');
  if (sheet) sheet.classList.add('show');
  document.body.style.overflow = 'hidden';
}
var bounceTimer = null;
function bounceRack() {
  var btn = document.getElementById('cartBtn');
  if (!btn) return;
  btn.classList.remove('bounce');
  void btn.offsetWidth;
  btn.classList.add('bounce');
  if (bounceTimer) clearTimeout(bounceTimer);
  bounceTimer = setTimeout(function () { btn.classList.remove('bounce'); }, 600);
}
var MAX_SHIRTS = 5;
function shirtPaths(x, stroke, sw, opacity) {
  var h = sw * 0.6;
  return '<g opacity="' + opacity + '">' +
    '<path d="M' + x + ' 7 Q' + x + ' 4 ' + (x + 2.5) + ' 4 Q' + (x + 6) + ' 4 ' + (x + 6) + ' 7 Q' + (x + 6) + ' 9.5 ' + (x + 3) + ' 10.5" stroke="' + stroke + '" stroke-width="' + h + '" fill="none" stroke-linecap="round"/>' +
    '<line x1="' + x + '" y1="7" x2="' + x + '" y2="14" stroke="' + stroke + '" stroke-width="' + h + '"/>' +
    '<path d="M' + x + ' 14 Q' + (x - 10) + ' 17 ' + (x - 13) + ' 22" stroke="' + stroke + '" stroke-width="' + h + '" fill="none" stroke-linecap="round"/>' +
    '<path d="M' + x + ' 14 Q' + (x + 10) + ' 17 ' + (x + 13) + ' 22" stroke="' + stroke + '" stroke-width="' + h + '" fill="none" stroke-linecap="round"/>' +
    '<line x1="' + (x - 13) + '" y1="22" x2="' + (x + 13) + '" y2="22" stroke="' + stroke + '" stroke-width="' + h + '" stroke-linecap="square"/>' +
    '<line x1="' + (x - 11) + '" y1="22" x2="' + (x - 12) + '" y2="44" stroke="' + stroke + '" stroke-width="' + h + '" stroke-linecap="square"/>' +
    '<line x1="' + (x + 11) + '" y1="22" x2="' + (x + 12) + '" y2="44" stroke="' + stroke + '" stroke-width="' + h + '" stroke-linecap="square"/>' +
    '<line x1="' + (x - 12) + '" y1="44" x2="' + (x + 12) + '" y2="44" stroke="' + stroke + '" stroke-width="' + h + '" stroke-linecap="square"/>' +
    '</g>';
}
function updateRack(count) {
  var countEl = document.getElementById('navCount');
  var shirts = document.getElementById('navShirts');
  if (countEl) {
    countEl.textContent = count;
    if (count > 0) countEl.classList.add('visible');
    else countEl.classList.remove('visible');
  }
  if (shirts) {
    if (count === 0) { shirts.innerHTML = ''; return; }
    var shown = Math.min(count, MAX_SHIRTS);
    var html = '';
    for (var i = 0; i < shown; i++) {
      var offset = (i - (shown - 1) / 2) * 5;
      var x = 32 + offset;
      var isLatest = i === shown - 1;
      var op = isLatest ? 1 : 0.2 + (i / shown) * 0.25;
      var col = isLatest ? 'currentColor' : '#C8C2B8';
      html += shirtPaths(x, col, 2, op);
    }
    shirts.innerHTML = html;
  }
}
function addToCartAjax(variantId, quantity, productTitle, variantTitle, price, image) {
  quantity = quantity || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(function (r) { return r.json(); })
  .then(function () {
    return fetch('/cart.js');
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) {
    updateRack(cart.item_count);
    bounceRack();
    setTimeout(function () {
      showModal(productTitle, variantTitle, price, image);
    }, 350);
  })
  .catch(function (err) { console.error('Add to cart error:', err); });
}
var toastTimer = null;
function showToast(name) {
  var toast = document.getElementById('toast');
  var toastProduct = document.getElementById('toastProduct');
  if (!toast) return;
  if (toastProduct) toastProduct.textContent = name;
  if (toastTimer) clearTimeout(toastTimer);
  toast.classList.remove('show');
  void toast.offsetWidth;
  toast.classList.add('show');
  toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2500);
}
var sizeData = {
  XS: { Chest: [88, 34.6], Length: [65, 25.6], Shoulder: [40, 15.7], Sleeve: [60, 23.6] },
  S:  { Chest: [92, 36.2], Length: [67, 26.4], Shoulder: [42, 16.5], Sleeve: [61, 24.0] },
  M:  { Chest: [96, 37.8], Length: [69, 27.2], Shoulder: [44, 17.3], Sleeve: [62, 24.4] },
  L:  { Chest: [100, 39.4], Length: [71, 28.0], Shoulder: [46, 18.1], Sleeve: [63, 24.8] },
  XL: { Chest: [104, 40.9], Length: [73, 28.7], Shoulder: [48, 18.9], Sleeve: [64, 25.2] }
};
function openSizeGuide() {
  document.getElementById('sizeGuideOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  selectSgSize('XS', document.querySelector('.sg-size-btn'));
}
function closeSizeGuide(e) {
  if (e.target === document.getElementById('sizeGuideOverlay')) closeSizeGuideBtn();
}
function closeSizeGuideBtn() {
  document.getElementById('sizeGuideOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
function selectSgSize(size, btn) {
  document.querySelectorAll('.sg-size-btn').forEach(function (b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var data = sizeData[size];
  var tbody = document.getElementById('sgTableBody');
  if (tbody) {
    tbody.innerHTML = Object.keys(data).map(function (key) {
      return '<tr><td>' + key + '</td><td>' + data[key][0] + ' cm</td><td>' + data[key][1] + ' in</td></tr>';
    }).join('');
  }
}
function toggleAccordion(el) {
  el.parentElement.classList.toggle('open');
}
var fadeEls = document.querySelectorAll('.fade-in');
if (fadeEls.length > 0 && 'IntersectionObserver' in window) {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.1 });
  fadeEls.forEach(function (el) { observer.observe(el); });
}
var heroPhoto = document.querySelector('.hero-photo');
if (heroPhoto) {
  window.addEventListener('scroll', function () {
    var scrolled = window.scrollY;
    var hero = document.querySelector('.hero');
    if (hero && scrolled < hero.offsetHeight) {
      heroPhoto.style.transform = 'scale(1.08) translateY(' + (scrolled * 0.25) + 'px)';
    }
  }, { passive: true });
}
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    closeSearch();
    closeModal();
    closeSizeGuideBtn();
    closeDrawer();
  }
});
fetch('/cart.js')
  .then(function (r) { return r.json(); })
  .then(function (cart) { updateRack(cart.item_count); })
  .catch(function () {});